import { render, staticRenderFns } from "./DuplicatePersonPopup.component.vue?vue&type=template&id=9ebc38d8"
import script from "./DuplicatePersonPopup.component.vue?vue&type=script&lang=js"
export * from "./DuplicatePersonPopup.component.vue?vue&type=script&lang=js"
import style0 from "./DuplicatePersonPopup.component.vue?vue&type=style&index=0&id=9ebc38d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports